import * as React from 'react';
import { UserState } from '../../../interface/MyInterfaces';
import { VendorReportState2025, VendorReportAction2025, NewVendorProfile } from '../../../interface/VendorReportInterface2025';
import * as Helpers from '../../Common/Helpers';
import { AverageEmployeesChart } from './AverageEmployeesChart';
import { AnnualEarningsChart } from './AnnualEarningsChart';
import { Hint, Sunburst } from 'react-vis';
import Switch from "react-switch";
import renderHTML from 'react-render-html';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { exportVendorChart } from './NewVendorReportButtonHelpers2025'
import ReactTooltip from 'react-tooltip';


class NewVendorSunburst2025 extends React.Component<VendorReportState2025 & UserState & VendorReportAction2025, NewVendorProfile> {
    constructor(props) {
        super(props);
        this.state = {
            hoveredCell: false,
            isClicked: false,
            pathValue: false,
            pathObj: false,
            finalValue: 'SUNBURST',
            data: this.props.decoratedData,
            //selected2: this.props.decoratedData ? this.props.decoratedData.children[0] : null,
            //selectedVendorProfile: this.props.decoratedData ? this.props.decoratedData.children[0].children[0].children[0] : null
            selected2: null,
            selectedVendorProfile: null,
            checked: false
        };
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.type !== prevProps.type) {
            this.reset();
        }
    }

    naicsInRange(level2_naics, level3_naics) {
        var split = level2_naics.split("-");
        if (level2_naics.includes('-') && split.length > 0) {
            return split[0] <=
                level3_naics.substr(0, 2) && level3_naics.substr(0, 2) <= split[1] 
        }
        return false;

    }

    // get highlighted naics sequences
    getParentPath = (node) => {
        if (node.title == "gap") {
            return;
        }
        if (!node.parent) {
            return ["root"];
        }
        return [node.data && node.data.naics || node.naics].concat(this.getParentPath(node.parent));
    };
    // get hovered sequence data object and its parents
    getAncestorNodes = (node) => {
        if (node.title == "gap") {
            return;
        }
        let result = [node.data || node];
        while (node.parent) {
            result.unshift(node.parent.data || node.parent);
            node = node.parent;
        }
        result = result.slice(1, );
        return result;
    };
    // change sunburst arcs fill-opacity on hover
    updateData = (data, parentPath) => {
        if (data.children) {
            data.children.map(child => this.updateData(child, parentPath));
        }
        data.style = {
            ...data.style,
            fillOpacity: parentPath && !parentPath[data.naics] ? 0.2 : 1
        };
        return data;
    };
    buildValue = (hoveredCell) => {
        const { radius, angle, angle0 } = hoveredCell;
        const trueAngle = (angle + angle0) / 2;
        return {
            x: radius * Math.sin(trueAngle),
            y: radius * Math.cos(trueAngle)-60
        }
    };
    // calculate total spending for each cell
    /*getCellSpending = (hoveredCell) => {
        if (hoveredCell.naics.toString().length == 3) {
            return hoveredCell.size ? hoveredCell.size : hoveredCell.children.reduce((total, child) => { return total + child.size }, 0);
        }
        return hoveredCell.children.map(child => this.getCellSpending(child)).reduce((total, spending) => total + spending);
    }*/
    reset = () => {
        this.setState({
            hoveredCell: false,
            isClicked: false,
            pathValue: false,
            pathObj: false,
            finalValue: false,
            data: this.updateData(this.props.decoratedData, false),
            selected2: null,
            selectedVendorProfile: null,
            checked: false
        });

    }
    clearSunburstState = () => {
        this.setState({
            pathValue: false,
            finalValue: false,
            pathObj: false,
            data: this.updateData(this.props.decoratedData, false),
            hoveredCell: false,
            isClicked: false,
            selectedVendorProfile: this.props.decoratedData.children[0].children[0].children[0]
        });
    };
    naics2Onclick = (data) => {
        this.clearSunburstState();
        this.setState({ selected4: null });
        this.setState({ selected3: null });
        this.setState({ selected2: data });
        this.setState({ selectedVendorProfile: data });
        const path = [data.naics];
        const pathAsMap = path.reduce((res, row) => {
            res[row] = true;
            return res;
        }, {});
        this.setState({
            pathObj: [data],
            data: this.updateData(this.props.decoratedData, pathAsMap),
            hoveredCell: data,
            isClicked: true
        });
    };
    naics3Onclick = (data) => {
        this.clearSunburstState();
        this.setState({ selected4: null });
        this.setState({ selected3: data });
        this.setState({ selectedVendorProfile: data });
        const path = this.state.selected2 ? [this.state.selected2.naics, data.naics] : [this.props.decoratedData.children[0].naics, data.naics];
        const pathAsMap = path.reduce((res, row) => {
            res[row] = true;
            return res;
        }, {});
        this.setState({
            pathObj: [this.state.selected2 || this.props.decoratedData.children[0], data],
            data: this.updateData(this.props.decoratedData, pathAsMap),
            hoveredCell: data,
            isClicked: true
        });
    };
    naics4Onclick = (data) => {
        this.clearSunburstState();
        this.setState({ selected4: data });
        this.setState({ selectedVendorProfile: data });
        const path2 = this.state.selected2 ? this.state.selected2 : this.props.decoratedData.children[0];
        const path3 = this.state.selected3 ? this.state.selected3 : this.state.selected2 ? this.state.selected2.children[0]: this.props.decoratedData.children[0].children[0];
        const path = [path2.naics, path3.naics, data.naics];
        const pathAsMap = path.reduce((res, row) => {
            res[row] = true;
            return res;
        }, {});
        this.setState({
            pathObj: [path2, path3, data],
            data: this.updateData(this.props.decoratedData, pathAsMap),
            hoveredCell: data,
            isClicked: true
        });
    };
    renderNaics3 = () => {
        if (this.state.selected2) {
            return this.state.selected2.children.map((d) => {
                if (d.title == "gap") return;
                let onListClick = this.naics3Onclick.bind(this, d);
                return <li key={d.naics} onClick={onListClick}
                    style={{
                        color: this.state.isClicked && this.state.pathObj.length>1 ? this.state.pathObj[1].naics == d.naics && d.color : 'black',
                        fontSize: this.state.isClicked && this.state.pathObj.length>1 ? this.state.pathObj[1].naics == d.naics && '1.5rem': '1.4rem'
                    }}
                >
                {d.naics + " : " + d.title + " " + Helpers.numberFormat(d.spent)}</li>
            });
        } /*else if (this.props.decoratedData) {
            return this.props.decoratedData.children[0].children.map((d) => {
                if (d.title == "gap") return;
                let onListClick = this.naics3Onclick.bind(this, d);
                return <li key={d.naics} onClick={onListClick}>
                {d.naics + " : " + d.title + " " + Helpers.numberFormat(d.spent)}</li>
            });
        }*/else {
            return null;
        }
    };
    //naics4 changes as naics3 changes otherwise render naics4 belong to first naics3
    renderNaics4 = () => {
        if (this.state.selected3) {
            return this.state.selected3.children.map((d) => {
                if (d.title == "gap") return;
                let onListClick = this.naics4Onclick.bind(this, d);
                return <li key={d.naics} onClick={onListClick}
                    style={{
                        color: this.state.isClicked && this.state.pathObj.length > 2 ? this.state.pathObj[2].naics == d.naics && d.color : 'black',
                        fontSize: this.state.isClicked && this.state.pathObj.length > 2 ? this.state.pathObj[2].naics == d.naics && '1.5rem' : '1.4rem'
                    }}
                >{d.naics + " : " + d.title + " " + Helpers.numberFormat(d.size)}</li>;
            });
        } else if (this.state.selected2) {
            return this.state.selected2.children[0].children.map((d) => {
                if (d.title == "gap") return;
                let onListClick = this.naics4Onclick.bind(this, d);
                return <li key={d.naics} onClick={onListClick}
                    style={{
                        color: this.state.isClicked && this.state.pathObj.length > 2 ? this.state.pathObj[2].naics == d.naics && d.color : 'black',
                        fontSize: this.state.isClicked && this.state.pathObj.length > 2 ? this.state.pathObj[2].naics == d.naics && '1.5rem' : '1.4rem'
                    }}
                > {d.naics + " : " + d.title + " " + Helpers.numberFormat(d.size)}</ li>;
            });
        } /*else if (this.props.decoratedData) {
            return this.props.decoratedData.children[0].children[0].children.map((d) => {
                if (d.title == "gap") return;
                let onListClick = this.naics4Onclick.bind(this, d);
                return <li key={d.naics} onClick={onListClick}>{d.naics + " : " + d.title + " " + Helpers.numberFormat(d.size)}</li>
            })
        }*/else{
            return null;
        }
    };
    renderDefinition = () => {
        if (this.state.selected4) {
            return this.state.selected4.definition;
        } else if (this.state.selected3) {
            return this.state.selected3.definition;
        } else if (this.state.selected2 && this.state.isClicked) {
            return this.state.selected2.definition;
        } else if (this.state.selected2) {
            return this.state.selected2.children[0].children[0].definition;
        }else {
            return null;
        }
    };
    employeeText=()=>{
        let university = this.state.selectedVendorProfile.university_emp_mean;
        let national = this.state.selectedVendorProfile.national_emp_mean;

        if (university > national)
            return (university - national) + " more";
        else if (university < national)
            return (national - university) + " less";
        else return "equal";
    }

    wageText=()=>{
        let university = this.state.selectedVendorProfile.university_wage_mean;
        let national = this.state.selectedVendorProfile.national_wage_mean;

        if (university > national)
            return (((university - national) / national) * 100).toFixed(0) + "% more than";
        else if (university < national)
            return (((national - university) / national) * 100).toFixed(0) + "% less than";
        else return "equal to";
    }
    handleToggleChange=(checked)=>{
        this.setState({ checked });
    }
    getTooltip(tooltipContent) {
        return (
            <Tooltip id="tooltip">
                <p>{tooltipContent}</p>
            </Tooltip>
        )
    }
    renderBullets = () => {
        //const maskedChart = require('../../../images/maskedChart.png');
        if (this.props.decoratedData && !this.state.selectedVendorProfile) {
            //this.setState({ selectedVendorProfile: this.props.decoratedData.children[0].children[0].children[0] });
            return null;
        }
        if (this.props.type == "BVD") {
            if (this.props.SunburstBulletPoint !== undefined) {
                //this.props.SunburstBulletPoint.filter(
                var thisOne, pct_small, pct_in_state, ct_small, ct_in_state, ct_national, spend_small, spend_national, spend_in_state;
                if (this.state.hoveredCell != false && this.state.finalValue != false) {
                    if (this.state.finalValue.length == 2 || this.state.finalValue.length == 5) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_2 == this.state.hoveredCell.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_2;
                        pct_in_state = thisOne.in_state_estab_pct_2;
                        ct_small = thisOne.small_business_estab_ct_2;
                        ct_in_state = thisOne.in_state_estab_ct_2;
                        ct_national = thisOne.national_estab_ct_2;
                        spend_small = thisOne.small_business_estab_spend_2;
                        spend_national = thisOne.national_estab_spend_2;
                        spend_in_state = thisOne.in_state_estab_spend_2;
                    }
                    else if (this.state.finalValue.length == 3) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_3 == this.state.hoveredCell.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_3;
                        pct_in_state = thisOne.in_state_estab_pct_3;
                        ct_small = thisOne.small_business_estab_ct_3;
                        ct_in_state = thisOne.in_state_estab_ct_3;
                        ct_national = thisOne.national_estab_ct_3;
                        spend_small = thisOne.small_business_estab_spend_3;
                        spend_national = thisOne.national_estab_spend_3;
                        spend_in_state = thisOne.in_state_estab_spend_3;
                    }
                    else if (this.state.finalValue.length == 4) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_4 == this.state.hoveredCell.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_4;
                        pct_in_state = thisOne.in_state_estab_pct_4;
                        ct_small = thisOne.small_business_estab_ct_4;
                        ct_in_state = thisOne.in_state_estab_ct_4;
                        ct_national = thisOne.national_estab_ct_4;
                        spend_small = thisOne.small_business_estab_spend_4;
                        spend_national = thisOne.national_estab_spend_4;
                        spend_in_state = thisOne.in_state_estab_spend_4;
                    }
                } else {
                 
                    if ((this.state.selected2 != null && this.state.selected3 == null && this.state.selected4 == null)) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_2 == this.state.selected2.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_2;
                        pct_in_state = thisOne.in_state_estab_pct_2;
                        ct_small = thisOne.small_business_estab_ct_2;
                        ct_in_state = thisOne.in_state_estab_ct_2;
                        ct_national = thisOne.national_estab_ct_2;
                        spend_small = thisOne.small_business_estab_spend_2;
                        spend_national = thisOne.national_estab_spend_2;
                        spend_in_state = thisOne.in_state_estab_spend_2;
                    }
                    else if ((this.state.selected2 != null && this.state.selected3 != null && this.state.selected4 == null)) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_3 == this.state.selected3.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_3;
                        pct_in_state = thisOne.in_state_estab_pct_3;
                        ct_small = thisOne.small_business_estab_ct_3;
                        ct_in_state = thisOne.in_state_estab_ct_3;
                        ct_national = thisOne.national_estab_ct_3;
                        spend_small = thisOne.small_business_estab_spend_3;
                        spend_national = thisOne.national_estab_spend_3;
                        spend_in_state = thisOne.in_state_estab_spend_3;
                    }else if ((this.state.selected2 != null && this.state.selected4 != null)) {
                        thisOne = this.props.SunburstBulletPoint.filter(x => x.naics_4 == this.state.selected4.naics)[0];
                        pct_small = thisOne.small_bus_estab_pct_4;
                        pct_in_state = thisOne.in_state_estab_pct_4;
                        ct_small = thisOne.small_business_estab_ct_4;
                        ct_in_state = thisOne.in_state_estab_ct_4;
                        ct_national = thisOne.national_estab_ct_4;
                        spend_small = thisOne.small_business_estab_spend_4;
                        spend_national = thisOne.national_estab_spend_4;
                        spend_in_state = thisOne.in_state_estab_spend_4;
                    }
                }
         
                /*if (pct_small == null || pct_in_state == null)
                    return "Ownership identification cannot be performed on the NAICS";
                else */
                return (<div><ul>
                    <p style={{ fontSize: '1.6rem' }}><b>Industry Highlights</b></p>
                    <p>In the <b>{this.state.selectedVendorProfile.title}</b> industry (NAICS code {this.state.selectedVendorProfile.naics})</p>
                    <p>
                        {(!ct_small || !spend_small) && (!ct_national || !spend_national) && (!ct_in_state || !spend_in_state) && <li>No businesses received funding in this NAICS code.</li>}
                        
                        {ct_national && spend_national && <li><b>{Helpers.numberWithCommas(ct_national)}</b> {ct_national > 1 ? "businesses" : "business"} received <b>{Helpers.billionNumberFormat(spend_national)}</b>.</li>}
                        {ct_in_state && spend_in_state && <li><b>{Helpers.numberWithCommas(ct_in_state)}</b> in-state {ct_in_state > 1 ? "businesses" : "business"} received <b>{Helpers.billionNumberFormat(spend_in_state)}</b>.</li>}
                        {ct_small && spend_small && <li><b>{Helpers.numberWithCommas(ct_small)}</b> small {ct_small > 1 ? "businesses" : "business"} received <b>{Helpers.billionNumberFormat(spend_small)}</b>.</li>}
                    </p>
            </ul></div>)
            }
            else
                return (<div>loading...</div>)
        }
        else {
            if (this.props.HomeState && this.state.selectedVendorProfile) {
                /*if (this.state.selectedVendorProfile.spent == "(masked)") {
                    return (
                        <div>
                            <div className="barCharts">
                                <img src={String(maskedChart)} width="580px" />
                            </div>
                            <div><ul>
                                <li>Unique establishments in this industry have been masked by the U.S. Census Bureau for privacy.</li>
                                <li>Number of people employed by each of those businesses have been masked by the U.S. Census Bureau for privacy.</li>
                            </ul></div>
                        </div>
                    );
                }*/
                return (
                    <div>
                        <div>
                            <div className="toggle__nation_average">
                                <label>
                                    <span>Include National Average</span>
                                    <Switch onChange={this.handleToggleChange} checked={this.state.checked} />
                                </label>
                            </div>
                            <div className="barCharts">
                                <AverageEmployeesChart normal_or_large={0} scale={0.5} selectedVendorProfile={this.state.selectedVendorProfile} withNational={this.state.checked} />
                                <AnnualEarningsChart normal_or_large={0} scale={0.5} selectedVendorProfile={this.state.selectedVendorProfile} withNational={this.state.checked} />
                            </div>
                        </div>
                        <div>
                            <p className="industry_highlight_p" style={{ fontSize: '1.6rem' }}><b>Industry Highlights</b></p>
                            <ul className="industry_highlight_bullets">
                            <li>{this.props.agg ? this.props.HomeState && this.props.HomeState.campusname : this.props.HomeState && this.props.HomeState.the_university && this.props.HomeState.the_university.charAt(0).toUpperCase() + this.props.HomeState.the_university.slice(1)} purchased <b>{Helpers.billionNumberFormat(this.state.selectedVendorProfile.spent)}</b> in goods and services from <b>{Helpers.numberWithCommas(this.state.selectedVendorProfile.vendor)} unique establishments</b> in the <b>{this.state.selectedVendorProfile.title}</b> industry.</li>
                            <li>On average, each of those businesses employed approximately <b>{Helpers.numberWithCommas(this.state.selectedVendorProfile.university_emp_mean)} people.</b></li>
                            <li>Establishments that supplied {this.props.HomeState && this.props.HomeState.campusname} research projects are associated with firms that have, on average, <b>{this.employeeText()} employees</b> than the national average for this industry.</li>
                            <li>{this.props.HomeState && this.props.HomeState.campusname} research supports firms that pay <b>{this.wageText()}</b> the national average for this industry.</li>
                        </ul></div>
                    </div>
                );
            }
        }
    };
    onValueMouseOut = () => {
        this.clearSunburstState();
        this.setState({
            //selected2: null,
            selected3: null,
            selected4: null
        });
    }
    //set text color dynamically on top of background color
    getColorLightness = (hslString) => {
        hslString = hslString.replace(/[()]/g, '').slice(3);
        let indexofLightness = hslString.lastIndexOf(",") + 1;
        const lightness = parseFloat(hslString.slice(indexofLightness));
        return lightness;
    }

    render() {
        var names = [];

        function getNames(node) {
            if (node.children) {
                names.push(node.title);

                try {
                    if (node.naics.length < 2)
                        node.children.forEach(function (c) { getNames(c); });
                }
                catch (e) {
                    node.children.forEach(function (c) { getNames(c); });

                }
            }
        }

        getNames(this.props.decoratedData);

        const { hoveredCell, isClicked, pathObj, selected2, selected3, selected4 } = this.state;

		const min_year = (this.props as any).VendorReport_Tab4?.BVDYearRange_start_fy;
		const max_year = (this.props as any).VendorReport_Tab4?.BVDYearRange_end_fy;
        return <div className='firstTab tabcontents container-fluid vendor-report-content'>
            <div className='row'>
                <div className="col-md-12">
                    <div className="bullets--before">
                        <div className="newVendorTitleDiv">
                            <h3>{(this.props.type == "BVD") ? this.props.VendorReport_Tab4 && renderHTML(this.props.VendorReport_Tab4.title) : this.props.VendorReport_Tab3 ? renderHTML(this.props.VendorReport_Tab3.title) : "loading.."}
                            </h3>
                        </div>
                        <p>
                            {(this.props.type == "BVD") ? this.props.VendorReport_Tab4 && renderHTML(this.props.VendorReport_Tab4.top_description) : this.props.VendorReport_Tab3 && renderHTML(this.props.VendorReport_Tab3.top_description)}
                        </p>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-12" style={{ "paddingTop": "0", "marginBottom": "10px", "marginTop": "0" }}>
                    <div className="boxshadow-div">
                        <h3 style={{ paddingBottom: "10px" }}><b>Highlights</b></h3>
                        {(this.props.type == "BVD") ? this.props.VendorReport_Tab4 && renderHTML(this.props.VendorReport_Tab4.bullets) : this.props.VendorReport_Tab3 && renderHTML(this.props.VendorReport_Tab3.bullets)}

                        <span style={{ "display": "inline-block", "width": "100%", paddingBottom: "10px", fontSize: "16px", fontWeight: "bold" }}>Exploring Industry Impact</span>
                        {(this.props.type == "BVD") ? this.props.VendorReport_Tab4 && renderHTML(this.props.VendorReport_Tab4.instructions) : this.props.VendorReport_Tab3 && renderHTML(this.props.VendorReport_Tab3.instructions)}
                        
                        <div className="description">
                            {pathObj && pathObj.map((sequence) =>
                                <div className="sunburst__sequence" style={{ background: sequence.color == "#fff" ? "#4b0082" : sequence.color }}>
                                    <div style={{
                                        marginLeft: '1.8em',
                                        content: '', position: 'absolute', top: '50%', marginTop: '-1.8em', borderWidth: '1.8em 0 1.8em 1em',
                                        borderStyle: 'solid', left: '-1em',
                                        borderColor: (sequence.color == "#fff" ? "#4b0082" : sequence.color) + ' ' + (sequence.color == "#fff" ? "#4b0082" : sequence.color) + ' ' + (sequence.color == "#fff" ? "#4b0082" : sequence.color) + ' ' + 'transparent', color: sequence.color == "#fff" ? "#4b0082" : sequence.color
                                    }}></div>
                                    <p style={{ color: this.getColorLightness(sequence.color) > 51 ? '#000' : '#f9f9f9' }}><span>&nbsp;{sequence.naics}</span><span>{sequence.title}</span></p>
                                    <div style={{
                                        marginLeft: '1.8em',
                                        content: '', position: 'absolute', top: '50%', marginTop: '-1.8em', borderTop: '1.8em solid transparent',
                                        borderBottom: '1.8em solid transparent', borderLeft: '1em solid ' + (sequence.color == "#fff" ? "#4b0082" : sequence.color), right: '-1em'
                                    }}></div>
                                </div>
                            )}
                        </div>

                        <Row className='big-cards-div' id="sunburst_chart">
                            <Col className="sunburst">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <a className="export" onClick={
                                        () => exportVendorChart(
                                            "#sunburst_chart",
                                            "sunburst_chart.png",
                                            this.props.display_id,
                                            this.state.currentDateTime,
                                            this.props.HomeState.campusname,
                                            "",
                                            this.props.report_vintage_vendor2025)}>
                                        <i className="fa fas fa-download new-vendor-report"></i>EXPORT CHART
                                    </a>
                                    <span tabIndex={1}
                                        data-tip={this.props.VendorReport_Tab4.chartTooltip}
                                        data-for="sunburstChartToolTip"
                                        data-class="vendorReportChartToolTipStyling"
                                        style={{ marginLeft: 'auto', color: 'gray' }}>
                                        <span className='help'>
                                            <i className="fa fa-info-circle fa-lg zoomhelp-icon"></i>Info
                                        </span>
                                    </span>
                                    <ReactTooltip id="sunburstChartToolTip" multiline={true} />
                                </div>
                                <Sunburst
                                    animation
                                    hideRootNode
                                    width={550}
                                    height={550}
                                    colorType="literal"
                                    data={this.props.decoratedData ? this.props.decoratedData : {}}
                                    style={{ stroke: '#fff', strokeOpacity: 0.3 }}
                                    onValueMouseOver={
                                        node => {
                                            if (node.title == "gap") {
                                                return;
                                            }
                                            if (isClicked) {
                                                return;
                                            }
                                            const path = this.getParentPath(node).reverse();
                                            const pathAsMap = path.reduce((res, row) => {
                                                res[row] = true;
                                                return res;
                                            }, {});
                                            this.setState({
                                                finalValue: path[path.length - 1],
                                                pathValue: path.slice(1, ).join('>'),
                                                pathObj: this.getAncestorNodes(node),
                                                data: this.updateData(this.props.decoratedData, pathAsMap),
                                                hoveredCell: node,
                                                //hover opens corresponding naics list section on the right
                                                selected2: this.getAncestorNodes(node) ? this.getAncestorNodes(node)[0] : null,
                                                selected3: this.getAncestorNodes(node)[1] ? this.getAncestorNodes(node)[1] : null,
                                                selected4: this.getAncestorNodes(node)[2]? this.getAncestorNodes(node)[2] : null,
                                                selectedVendorProfile: node
                                            });
                                        }}
                                    onValueMouseOut={
                                        () => {
                                            if (!isClicked) {
                                                this.reset();
                                            }
                                        }
                                    }
                                    onValueClick={(node) => {
                                        if (node.title == "gap") return;
                                        
                                        if (isClicked) {
                                            // Already in clicked mode - exit to hover mode
                                            // Process the clicked node (which is the one currently under the mouse) to show its info
                                            const path = this.getParentPath(node).reverse();
                                            const pathAsMap = path.reduce((res, row) => {
                                                res[row] = true;
                                                return res;
                                            }, {});
                                            const ancestorNodes = this.getAncestorNodes(node);
                                            this.setState({
                                                isClicked: false,
                                                finalValue: path[path.length - 1],
                                                pathValue: path.slice(1, ).join('>'),
                                                pathObj: ancestorNodes,
                                                data: this.updateData(this.props.decoratedData, pathAsMap),
                                                hoveredCell: node,
                                                selected2: ancestorNodes ? ancestorNodes[0] : null,
                                                selected3: ancestorNodes[1] ? ancestorNodes[1] : null,
                                                selected4: ancestorNodes[2] ? ancestorNodes[2] : null,
                                                selectedVendorProfile: node
                                            });
                                        } else {
                                            // Enter clicked mode - lock the currently hovered node's info
                                            // Use the current hoveredCell, or if not set, use the clicked node
                                            const nodeToLock = this.state.hoveredCell || node;
                                            const path = this.getParentPath(nodeToLock).reverse();
                                            const pathAsMap = path.reduce((res, row) => {
                                                res[row] = true;
                                                return res;
                                            }, {});
                                            const ancestorNodes = this.getAncestorNodes(nodeToLock);
                                            this.setState({
                                                isClicked: true,
                                                finalValue: path[path.length - 1],
                                                pathValue: path.slice(1, ).join('>'),
                                                pathObj: ancestorNodes,
                                                data: this.updateData(this.props.decoratedData, pathAsMap),
                                                hoveredCell: nodeToLock,
                                                selected2: ancestorNodes ? ancestorNodes[0] : null,
                                                selected3: ancestorNodes[1] ? ancestorNodes[1] : null,
                                                selected4: ancestorNodes[2] ? ancestorNodes[2] : null,
                                                selectedVendorProfile: nodeToLock
                                            });
                                        }
                                    }}
                                    padAngle={() => 0.01}
                                >
                                    {hoveredCell && !selected2 && !selected3 && !selected4 ? <Hint value={this.buildValue(hoveredCell)}>
                                        <div className="sunburst__tooltip">
                                            {hoveredCell.naics ? hoveredCell.naics : null}
                                        </div>
                                    </Hint> : null}
                                    {hoveredCell ?
                                        <div className="sunburst__tooltip--center">
                                            <p>{hoveredCell.title}</p>
                                            <p><b>{Helpers.numberFormat(hoveredCell.size ? hoveredCell.size : hoveredCell.spent)}</b></p>
                                        </div> : null}
                                </Sunburst>
                                <div className="bullets">

                                    {this.renderBullets()}

                                </div>
                            </Col>
                            <Col className="sunburst-right">
                                <div className="naics-two">
                                    <h5><b>Top Industry (NAICS) Sectors Receiving Research Spending from {this.props.HomeState && (Helpers.isAllIris(this.props.institutionName || this.props.HomeState?.campusname)) ? "IRIS member institutions" : this.props.institutionName}, {(min_year == max_year) ? min_year : `${min_year}-${max_year}`}</b></h5>
                                    {/*<h6>In order of total funds received between {min_year} and {max_year}</h6>*/}
                                    <table className="naics_table">
                                        <thead>
                                            <tr>
                                                {/*<th></th>*/}
                                                {/*<th>Rank</th>*/}
                                                <th colSpan={2}>Industry (NAICS Code)</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.props.decoratedData ? this.props.decoratedData.children.map((d, index) => {
                                                    let onListClick = this.naics2Onclick.bind(this, d);
                                                    if (d.title == "gap") return;
                                                    return (<tr><td colSpan={3}><table className="naics_table2"><tr>
                                                        <td>
                                                            <div style={{ width: "15px", height: "15px", display: "inline-block", background: d.color }}></div>
                                                            {/*
                                                            <span
                                                            style={{
                                                                fontWeight: isClicked && pathObj && (pathObj[0].naics == d.naics) ? 'bold' : 'normal',
                                                                fontSize: isClicked && pathObj && (pathObj[0].naics == d.naics) ? '1.5rem' : '1.4rem'
                                                            }}>{index + 1}</span>*/}
                                                        </td>
                                                        <td><span
                                                            style={{
                                                                fontWeight: isClicked && pathObj && (pathObj[0].naics == d.naics) ? 'bold': 'normal',
                                                                fontSize: isClicked && pathObj && (pathObj[0].naics == d.naics) ? '1.5rem' : '1.4rem',
                                                                cursor: "pointer"
                                                            }}
                                                            key={d.naics} onClick={onListClick}>{d.title} ({d.naics})
                                                        </span></td>
                                                        <td style={{ "textAlign": "right" }}><span
                                                            style={{
                                                                fontWeight: isClicked && pathObj && (pathObj[0].naics == d.naics) ? 'bold' : 'normal',
                                                                fontSize: isClicked && pathObj && (pathObj[0].naics == d.naics) ? '1.5rem' : '1.4rem'
                                                            }}>{Helpers.billionNumberFormat(d.spent)}</span></td>
                                                    </tr>
                                                        <tr><td colSpan={3}>
                                                            {(this.state.selected2) && 
                                                                this.state.selected2.children.map((d_naics3, index_naics3) => {
                                                                let onListClick_naics3 = this.naics3Onclick.bind(this, d_naics3);
                                                                if (d_naics3.title == "gap") return;
                                                                var naicsNotInRange = !this.naicsInRange(d.naics, d_naics3.naics);
                                                                if (d_naics3.naics &&
                                                                    ((naicsNotInRange)
                                                                        &&
                                                                        (d.naics != d_naics3.naics.substr(0, 2))
                                                                    )) return;
                                                                
                                                                return <table style={{ width: "97%", backgroundColor: "#fff4de"}}>
                                                                    <tr>
                                                                        <td><span
                                                                            style={{
                                                                                fontWeight: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? 'bold' : 'normal',
                                                                                fontSize: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? '1.3rem' : '1.3rem'
                                                                            }}></span></td>
                                                                        <td><span
                                                                            style={{
                                                                                fontWeight: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? 'bold' : 'normal',
                                                                                fontSize: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? '1.3rem' : '1.3rem',
                                                                                cursor: "pointer"
                                                                            }}
                                                                            key={d_naics3.naics} onClick={onListClick_naics3}>&#8226; {d_naics3.title} ({d_naics3.naics})
                                                                        </span></td>
                                                                        <td style={{ "textAlign": "right" }}><span
                                                                            style={{
                                                                                fontWeight: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? 'bold' : 'normal',
                                                                                fontSize: isClicked && this.state.pathObj.length > 1 && (pathObj[1].naics == d_naics3.naics) ? '1.3rem' : '1.3rem'
                                                                            }}>{Helpers.billionNumberFormat(d_naics3.spent)}</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={3}>
                                                                            {(this.state.selected3) ?
                                                                                this.state.selected3.children.map((d_naics4, index_naics4) => {
                                                                                    let onListClick_naics4 = this.naics4Onclick.bind(this, d_naics4);

                                                                                    if (d_naics4.title == "gap") return;

                                                                                    if (d_naics3.naics != d_naics4.naics.substr(0, 3)) return;

                                                                                    return <table style={{ marginLeft: "20px", width: "95%", backgroundColor: "white" }}>
                                                                                        <tr>
                                                                                            <td><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem'
                                                                                                }}></span></td>
                                                                                            <td><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem',
                                                                                                    cursor: "pointer"
                                                                                                }}
                                                                                                key={d_naics4.naics} onClick={onListClick_naics4}>&#x25CB; {d_naics4.title} ({d_naics4.naics})
                                                                                            </span></td>
                                                                                            <td style={{ "textAlign": "right" }}><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem'
                                                                                                }}>{Helpers.billionNumberFormat(d_naics4.size)}</span></td>
                                                                                        </tr>
                                                                                    </table>
                                                                                }) :
                                                                            (this.state.selected2) &&
                                                                                this.state.selected2.children[0].children.map((d_naics4, index_naics4) => {
                                                                                    let onListClick_naics4 = this.naics4Onclick.bind(this, d_naics4);
                                                                                    
                                                                                    if (d_naics4.title == "gap") return;
                                                                                    if (d_naics3.naics != d_naics4.naics.substr(0, 3)) return;

                                                                                    return <table style={{ marginLeft: "20px", width: "95%", backgroundColor: "white" }}>
                                                                                        <tr>
                                                                                            <td><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem'
                                                                                                }}></span></td>
                                                                                            <td><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem',
                                                                                                    cursor: "pointer"
                                                                                                }}
                                                                                                key={d_naics4.naics} onClick={onListClick_naics4}>&#x25CB; {d_naics4.title} ({d_naics4.naics})
                                                                                            </span></td>
                                                                                            <td style={{ "textAlign": "right" }}><span
                                                                                                style={{
                                                                                                    fontWeight: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? 'bold' : 'normal',
                                                                                                    fontSize: isClicked && this.state.pathObj.length > 2 && (pathObj[2].naics == d_naics4.naics) ? '1.2rem' : '1.2rem'
                                                                                                }}>{Helpers.billionNumberFormat(d_naics4.size)}</span></td>
                                                                                        </tr>
                                                                                    </table>
                                                                                })}
                                                                        </td>
                                                                    </tr>
                                                                </table> 
                                                                })
                                                            }

                                                        </td>
                                                        </tr>
                                                    </table></td></tr>
                                                        )
                                                    }) : null
                                                }
                                        </tbody>
                                    </table>                                
                                </div>
                                <div className="definition" style={{ display: this.renderNaics3() ? '' : 'none' }}>
                                    <h5><b>NAICS Definition</b></h5>
                                    <p className="naics__definition">
                                        {this.renderDefinition()}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default withUserActionTracker(NewVendorSunburst2025, "Vendor Profile Report", "viewed Industry Revenue Analysis Tab");